<template>
  <VeeField
    v-slot="props"
    v-model="computedModelValue"
    :name="name"
    :label="label || name"
    :rules="rules"
    :validate-on-mount="validateOnMount"
  >
    <fou-select
      ref="fouSelectRef"
      :disable-auto-complete="disableAutoComplete"
      :disabled="disabled"
      :id="id"
      :class="inputClass"
      :input-class="inputClass"
      :tabindex="tabindex"
      :multiple="multiple"
      :deselect-from-dropdown="deselectFromDropdown"
      :name="name"
      :model-value="initialValue"
      :reduce="reduce"
      :options="options"
      :placeholder="placeholder"
      :type="type"
      :is-error="isError || Boolean(props.errors?.length)"
      :is-warning="isWarning"
      :customField= customField
      :foundryArray = foundryArray
      :searchable=searchable
      :truncate-label="truncateLabel"
      :on-change="
        v => {
          onChange?.()
        }
      "
      @option:selected="
        v => {
          $emit('option:selected', v)
        }
      "
      @option:deselected="
        v => {
          $emit('option:deselected', v)
        }
      "
      :clearSearchOnBlur="clearSearchOnBlur"
      @search:blur="onSearchBlur(props)"
      @search="(searchValue, onLoading) => $emit('search', searchValue, onLoading)"
      v-bind="props.field"
      @keydown.enter.prevent.stop
    />
    <div v-if="props.errors?.length && showErrorMessage">
      <p v-for="(error, i) in props.errors" :key="i" :class="errorClass" class="ml-0 mt-error">
        {{ error }}
      </p>
    </div>
  </VeeField>
</template>
<script setup>
import {computed, ref} from 'vue'
import FouSelect from 'components/form/fou-select/'
const props = defineProps({
  searchable: {
    type: Boolean,
    default: true
  },
  modelValue: {},
  rules: {},
  inputClass: {},
  id: {},
  name: {},
  initialValue: {},
  reduce: {
    type: Function,
    default: () => {}
  },
  options: {
    type: Array,
    default() {
      return []
    }
  },
  placeholder: {},
  type: {},
  errorClass: {
    type: [String, Object, Array],
    default: ''
  },
  tabindex: {},
  deselectFromDropdown: {
    type: Boolean,
    default: false
  },
  isWarning: {
    type: Boolean,
    default() {
      return false
    }
  },
  showErrorMessage: {
    type: Boolean,
    default: true
  },
  multiple: {
    type: Boolean,
    default: false
  },
  validateOnMount: {
    type: Boolean,
    default: false
  },
  isError: {
    type: Boolean,
    default() {
      return false
    }
  },
  disableAutoComplete: {
    type: Boolean,
    default: false
  },
  onChange: {
    type: Function,
    default: () => {}
  },
  disabled: {
    type: Boolean,
    default: false
  },
  customField: {
    type: String,
    default: ''
  },
  foundryArray: {
    type: Array
  },
  clearSearchOnBlur:{
    type:[Function, Boolean],
    default:()=> {}
  },
  truncateLabel: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:modelValue', 'option:selected', 'search', 'option:deselected', 'search:blur'])
const computedModelValue = computed({
  get: () => props.modelValue,
  set: v => {
    emit('update:modelValue', v)
  }
})

const fouSelectRef = ref({})

function onSearchBlur(searchProps) {
  searchProps.validate()
  emit('search:blur')
}
</script>
